import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/rb_robot",
    name: "rb_robot",
    redirect: "/rb_robot/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "rb_robot_index",
        meta: {title: "机器人管理",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/rb/robot/index")
      }
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/rb.js